import React from "react";
import "./Spinner.css";

const Spinner: React.FC = () => {
  return <div className="spinner" />;
};

export default Spinner;
